import { render } from "./Use.vue?vue&type=template&id=71d907cf"
import script from "./Use.vue?vue&type=script&lang=js"
export * from "./Use.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__